import { render, staticRenderFns } from "./SitingAddDiglog.vue?vue&type=template&id=127b9e3a&scoped=true"
import script from "./SitingAddDiglog.vue?vue&type=script&lang=js"
export * from "./SitingAddDiglog.vue?vue&type=script&lang=js"
import style0 from "./SitingAddDiglog.vue?vue&type=style&index=0&id=127b9e3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127b9e3a",
  null
  
)

export default component.exports